import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/popover';
import { Day } from '@/domain/termine/type';
import { Termin } from '@/domain/termine/shared/types/Termin';
import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/utils';
import { TerminEntry } from '@/domain/termine/features/Calendar/Grid/Termin/TerminEntry';

export function DayPopover({ termine, day }: { termine: Termin[]; day: Day }) {
  const { t } = useTranslation();

  return (
    <Popover modal>
      <PopoverTrigger asChild>
        <span
          onClick={(e) => e.stopPropagation()}
          className={cn(
            'flex items-center justify-start',
            'rounded-xs p-1 text-xs',
            'text-neutrals-800',
            'cursor-pointer transition',
            'hover:bg-neutrals-200 hover:shadow-lg',
          )}>
          {`+ ${termine.length} ${t('domain.termine.additionalEvents')}`}
        </span>
      </PopoverTrigger>
      <PopoverContent
        side="right"
        align="center"
        className="flex flex-col w-72 bg-white shadow-lg p-4 rounded-xs max-h-96"
        onInteractOutside={(e) => {
          e.stopPropagation();
        }}>
        <div className="flex flex-row gap-1 font-semibold items-center">
          <span className="capitalize">
            {t('domain.termine.additionalEvents')}{' '}
            {day.locale('de').format('DD. MMMM')}
          </span>
        </div>
        <div className="flex-1 overflow-y-auto">
          <TerminEntry termine={termine} />
        </div>
      </PopoverContent>
    </Popover>
  );
}
